import * as React from 'react';
import './calendly.css';
import Modal from './Modal';

class PopupWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.onClick = this.onClick.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onClick() {
    this.setState({
      isOpen: true,
    });
  }

  onClose(e) {
    e.stopPropagation();

    this.setState({
      isOpen: false,
    });
  }

  render() {
    return (
      <div className='btn-small-outline w-button' onClick={this.onClick}>
        <div className='calendly-badge-widget'>
          Schedule a Call
        </div>

        <Modal
          {...this.props}
          open={this.state.isOpen}
          onModalClose={this.onClose}
          rootElement={this.props.rootElement}
        />
      </div>

    );
  }
}

export default PopupWidget;



// WEBPACK FOOTER //
// ./src/components/Calendly/index.js